import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import * as shoppingCartSelectors from '~/store/legacy/selector/shoppingCartSelectors';
import PriceLinesView from '../orders/PriceLinesView.jsx';

export default PriceLines;

function PriceLines(props) {
  const { variant = 'contained' } = props;

  const amountGroups = useSelector(shoppingCartSelectors.checkoutAmountsGrouped);
  const subTotal = useSelector(shoppingCartSelectors.checkoutSubtotalAmount);
  const amountDeductions = useSelector(shoppingCartSelectors.selectCheckoutAmountDeductions);

  if (!amountGroups) {
    return null;
  }

  return (
    <PriceLinesView variant={variant}
      amountGroups={amountGroups}
      subTotal={subTotal}
      amountDeductions={amountDeductions}
    />
  );
}

PriceLines.propTypes = {
  variant: PropTypes.oneOf(['contained', 'simple']),
};

